import { render, staticRenderFns } from "./RoomTypeForm.vue?vue&type=template&id=09df180b&"
import script from "./RoomTypeForm.vue?vue&type=script&lang=js&"
export * from "./RoomTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports